import { AdminService } from './../../services/admin.service';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { ApiService } from 'src/app/services/api.service';
import { NgbModalRef, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-add-employees',
  templateUrl: './add-employees.component.html',
  styleUrls: ['./add-employees.component.scss']
})
export class AddEmployeesComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string; }[];
  activation: boolean = true;
  priviledge: boolean = true;
  selectAll: boolean = false;
  entryGate: any = [];
  meetingRoomAccess: any = [];
  deskAccess: any = [];
  privateSuiteAccess: any = [];
  isinvite: boolean = false;
  name: boolean;
  email: boolean;
  mobile: boolean;
  dept;
  url: string;
  deptList: any;
  fullname = '';
  accessPointList: any;
  emailId = '';
  phoneNumber = '';
  departmentName: any = '';
  accessPointChanged = [];
  useraccessPointChanged = [];
  token: any;
  tenantId: any;
  ClickError: boolean = false;
  fieldErrors: any = [];
  searchDept: string = ''
  operation = true;
  disableAdd: boolean = false;
  @ViewChild("activationPopup", { static: false }) activationPopup: NgbModalRef;
  activateText: string = "";
  closeResult: string;

  // accessPointChanged:{ type: string; AccessPointId: any; CreatedBy: any; }[];
  constructor(private modalService: NgbModal, private router: Router, private apiService: ApiService, private appStateSrv: AppStateProvider,
    private adminSrv: AdminService, private zone: NgZone) { }

  ngOnInit(): void {
    this.getApiauthorizationToken();
    // this.entryGate = [
    //   { label: 'Turnstile 01', selected: true,Id:0,selectedIndex:0},
    //   { label: 'Turnstile 02', selected: true,Id:1,selectedIndex:1 },
    // ];
    // this.meetingRoomAccess = [
    //   { label: 'Adventurer', selected: true,Id:0,selectedIndex:0},
    //   { label: 'Passion', selected: true,Id:1,selectedIndex:1 },
    //   { label: 'Utopia', selected: true,Id:1,selectedIndex:2 },
    //   { label: 'Momentum', selected: true,Id:1,selectedIndex:3 },
    //   { label: 'Rocket', selected: true,Id:1,selectedIndex:4 },
    //   { label: 'Carnival', selected: true,Id:1,selectedIndex:5 }

    // ];
    // this.deskAccess = [
    //   { label: 'Flexi Desk 1', selected: true,Id:0,selectedIndex:0},
    //   { label: 'Flexi Desk 2', selected: true,Id:1,selectedIndex:1 },
    //   { label: 'Flexi Desk 3', selected: true,Id:1,selectedIndex:2 },
    // ];
    // this.privateSuiteAccess = [
    //   { label: 'PS 01', selected: true,Id:0,selectedIndex:0},
    //   { label: 'PS 02', selected: true,Id:1,selectedIndex:1 },
    //   { label: 'PS 03', selected: true,Id:1,selectedIndex:2 },
    // ];
    // this.meetingNav=[
    //   {
    //     index:"1",
    //     name:"Employees",
    //     link: '/employees/employees-list/add-employees'
    //   }
    //   ]

    const route = {
      index: "1",
      name: "Employees",
      link: '/employees/employees-list/add-employees'
    };
    this.appStateSrv.setSideNavState(route);
  }

  open(content) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: 'custom-class' }
    ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closeModal() {
    this.activation = !this.activation
  }

  toggle(event) {
    // this.activation = !this.activation;
    if (!this.activation) {
      this.activateText = 'De-Activate'
    }
    if (this.activation) {
      this.activateText = 'Activate'
    }
    this.open(this.activationPopup)
  }


  toggleActivationSelection(show) {
    // this.activation = !this.activation;
    this.modalService.dismissAll();
    if (this.activation) {
      this.entryGate.forEach((data, index) => {
        // data.selected = true;
        // this.changeAccess(data, 'entryGate', index)
      }
      );
      this.meetingRoomAccess.forEach((data, index) => {
        // data.selected = true;
        // this.changeAccess(data, 'meetingRoomAccess', index)
      }
      );
      this.deskAccess.forEach((data, index) => {
        // data.selected = true;
        // this.changeAccess(data, 'deskAccess', index)
      }
      );
      this.privateSuiteAccess.forEach((data, index) => {
        // data.selected = true;
        // this.changeAccess(data, 'privateSuiteAccess', index)
      }
      );
    }
    else {
      this.entryGate.forEach((data, index) => {
        // data.selected = false;
        // this.changeAccess(data, 'entryGate', index)
      }
      );
      this.meetingRoomAccess.forEach((data, index) => {
        // data.selected = false;
        // this.changeAccess(data, 'meetingRoomAccess', index)
      }
      );
      this.deskAccess.forEach((data, index) => {
        // data.selected = false;
        // this.changeAccess(data, 'deskAccess', index)
      }
      );
      this.privateSuiteAccess.forEach((data, index) => {
        // data.selected = false;
        // this.changeAccess(data, 'privateSuiteAccess', index)
      }
      );

    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }
  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();

    } else {
      popover.open();

    }
  }
  addEmployeeData(e) {
    e.preventDefault();
    console.log("dept", this.dept)

    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      console.log("Error", formStatus);
      this.fieldErrors = formStatus.errFields;
      console.log("fieldErrors", this.fieldErrors);
      window.scrollTo(0, 0);
      return;
    }
    this.fieldErrors = [];


    if (!this.fullname || this.fullname == "") {
      this.appStateSrv.showToast("Enter Full Name.");
      return;
    }
    if (String(this.fullname).length > 50) {
      this.appStateSrv.showToast("Please Enter Full Name less than 50 characters.");
      return;
    }
    if (!this.emailId || this.emailId == "") {
      this.appStateSrv.showToast("Enter Email ID.");
      return;
    }
    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.emailId)) {
    } else {
      this.appStateSrv.showToast("Enter Valid Email ID.");
      return;
    }
    if (!this.phoneNumber || this.phoneNumber == "") {
      this.appStateSrv.showToast("Enter Phone Number.");
      return;
    }
    if (String(this.phoneNumber).length != 10) {
      this.appStateSrv.showToast("Enter Valid Phone Number.");
      return;
    }
    if (!this.departmentName || this.departmentName == "") {
      this.appStateSrv.showToast("Select Department.");
      return;
    }
    const data = {
      userName: this.fullname,
      emailId: this.emailId.toLowerCase(),
      phoneNumber: '+91' + this.phoneNumber,
      departmentId: this.dept.id,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      canSendEmail: this.isinvite,
      isActive: this.activation,
      isPrivilege: this.priviledge
    };
    this.operation = false;
    this.disableAdd = true;
    this.apiService.post(APIs.addemployee, data, '').subscribe(
      result => {
        this.disableAdd = false;
        console.log("result", result)
        if (result.isValid == true) {
          localStorage.setItem(
            AppConstant.localStorage.selectedMember,
            result.data.userId
          );
          ;
          //this.addorupdateOrgEmployee();
          console.log('useraccessPointChanged', this.useraccessPointChanged);

          // if (this.useraccessPointChanged.length > 0) {
          //   const payload = {
          //     userId: result.data.userId,
          //     sendEmail: true,
          //     accessPointList: this.useraccessPointChanged,
          //     AccessOperationType: this.useraccessPointChanged[0].hasAccess
          //   }
          //   this.adminSrv.updateUserAccessPoint(payload).subscribe(response => {
          //     console.log('coadmin access response', response);
          //     // window.location.reload();
          //     this.router.navigate(["/employees/employees-list/add-employees/employee-add-status"]);
          //   })
          // } else

            this.router.navigate(["/employees/employees-list/add-employees/employee-add-status"]);
        }
        else {
          this.appStateSrv.showToast(result.errorMsg);
        }
        this.operation = true;
      },
      error => {
      }
    );
    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }


  formValidator(type: string = "add"): { valid: boolean, errFields: any } {

    const validate = (name, email, phone, dept) => {

      let errFields = [];

      if (type == 'name' || type == "add")
        if (!name || !/^[a-zA-Z ]{2,50}$/.test(name)) {

          if (name.length > 50) {

            const i = errFields.indexOf('namelen');
            console.log(i)
            console.log(errFields)

            if (i > -1)
              errFields.splice(i, 1);
            console.log(errFields)
            errFields.push('namelen');
            console.log(errFields)

          }
          else {
            const i = errFields.indexOf('namelen');
            if (i > -1)
              errFields.splice(i, 1);
          }
          const i = errFields.indexOf('name');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('name');
        }
        else {
          const i = errFields.indexOf('name');
          if (i > -1)
            errFields.splice(i, 1);
        }



      if (type == 'email' || type == 'add')
        if (
          !email ||
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
            email
          )
        ) {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('email');
        } else {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'phone' || type == "add")
        if (!phone || !/^\d{10}$/.test(phone)) {
          const i = errFields.indexOf('phone');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('phone');
        } else {
          const i = errFields.indexOf('phone');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (type == 'dept' || type == "add")
        if (!dept || dept == undefined || dept == '') {
          const i = errFields.indexOf('dept');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('dept');
        } else {
          const i = errFields.indexOf('dept');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (errFields.length > 0)
        return { valid: false, errFields: errFields };
      else
        return { valid: true, errFields: [] };
    }

    return validate(this.fullname, this.emailId, this.phoneNumber, this.departmentName);
  }

  inputModelChange(type: string) {
    this.textToLower();
    const formStatus = this.formValidator(type);
    this.fieldErrors = [];
    if (!formStatus.valid)
      this.fieldErrors = formStatus.errFields;
    return;

  }

  addorupdateOrgEmployee() {
    console.log("dept", this.dept)
    const data = {
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      userId: localStorage.getItem(AppConstant.localStorage.userId),
    };
    this.apiService.post(APIs.addorupdateOrgEmployee, data, '').subscribe(
      result => {
        console.log("result", result)
          ;
        this.addEmployee();
      },
      error => {
      }
    );
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.getDepartmentList();

      this.getAccessPointList();
    }
    //});
  };
  sendInvite(value) {
    this.isinvite = !this.isinvite;
    console.log(this.isinvite)
    console.log("event", value)
  }
  onCancel() {
    this.router.navigate(["/employees/employees-list"]);
  }
  getDepartmentList() {
    this.url = APIs.getDepartmentList;
    this.apiService.get(this.url, '').subscribe(
      (response: any) => {
        this.deptList = response;
        console.log(this.deptList)
      },
      err => console.log('error', err)
    );
  }
  getAccessPointList() {
    // this.url = APIs.getAccessPoint;
    this.url = APIs.getTenantSavedAccessPoints;
    const param = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    this.apiService.get(this.url, param).subscribe(
      (response: any) => {
        this.accessPointList = response;
        this.setAccessPoint();
        console.log('accessPointList', this.accessPointList)
      },
      err => console.log('error', err)
    );

  }
  setAccessPoint() {
    console.log('this.accessPointList[0]', this.accessPointList)
    this.accessPointList.list.forEach((data) => {
      console.log(data.accessPoint.type)
      console.log(data.type);
      let temp = {
        type: null,
        AccessPointId: null,
        CreatedBy: null,
        hasAccess: false
      }
      if (data.accessPoint.type == 'entry_gate') {

        data.selected = false;
        this.entryGate.push(data.accessPoint);

      }
      else if (data.accessPoint.type == 'meeting_room') {
        data.selected = false;
        this.meetingRoomAccess.push(data.accessPoint);
      }
      else if (data.accessPoint.type == 'team_room') {
        data.selected = false;
        this.privateSuiteAccess.push(data.accessPoint);
      }
      else if (data.accessPoint.type == 'desk') {
        data.selected = false;
        this.deskAccess.push(data.accessPoint);
      }
      if (data.accessPoint.type == 'desk' || data.accessPoint.type == 'team_room' || data.accessPoint.type == 'meeting_room' || data.accessPoint.type == 'entry_gate') {
        temp.AccessPointId = data.accessPointId;
        temp.CreatedBy = data.createdBy;
        temp.type = data.accessPoint.type;
        this.useraccessPointChanged.push(temp);
      }

    })
    console.log("this.entryGtae", this.entryGate)
    console.log("this.meetingRoomAccess", this.meetingRoomAccess)
    console.log("this.privateSuiteAccess", this.privateSuiteAccess)
    console.log("this.deskAccess", this.deskAccess)

  }
  setDepartment(dept) {
    this.dept = dept;
    this.departmentName = dept.department;
  }

  togglePriviledgeSelection(show) {
    // this.priviledge = !this.priviledge;
  }

  toggleSelectAllSelection(show) {

    if (this.selectAll) {
      this.entryGate.forEach((data, index) => {
        data.selected = false;
        this.changeAccess(data, 'entryGate', index)
      }

      );
      this.meetingRoomAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          this.changeAccess(data, 'meetingRoomAccess', index)
        }

      }
      );
      this.deskAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          this.changeAccess(data, 'deskAccess', index)
        }

      }
      );
      this.privateSuiteAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = false;
          this.changeAccess(data, 'privateSuiteAccess', index)
        }

      }
      );
    } else {
      this.entryGate.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          this.changeAccess(data, 'entryGate', index)
        }

      }

      );
      this.meetingRoomAccess.forEach((data, index) => {
        if (!data.isCLAModified) {

          data.selected = true;
          this.changeAccess(data, 'meetingRoomAccess', index)
        }

      }
      );
      this.deskAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          this.changeAccess(data, 'deskAccess', index)
        }

      }
      );
      this.privateSuiteAccess.forEach((data, index) => {
        if (!data.isCLAModified) {
          data.selected = true;
          this.changeAccess(data, 'deskAccess', index)
        }

      }
      );
    }

    // if(this.selectAll){
    //   this.entryGate.forEach(item => item.selected = true);
    //   this.meetingRoomAccess.forEach(item => item.selected = true);
    //   this.deskAccess.forEach(item => item.selected = true);
    //   this.privateSuiteAccess.forEach(item => item.selected = true);
    //  }
    //  else{
    //   this.entryGate.forEach(item => item.selected = false);
    //   this.meetingRoomAccess.forEach(item => item.selected = false);
    //   this.deskAccess.forEach(item => item.selected = false);
    //   this.privateSuiteAccess.forEach(item => item.selected = false);
    //  }
  }
  changeAccess(eg, module, i) {

    if (!this.activation) {
      return;
    }
    this.zone.run(() => {
      if (eg.selected)
        this.selectAll = false;
    })
    let data = eg;
    const mainIndex = this.useraccessPointChanged.findIndex(access => access.AccessPointId == data.id);

    if (module == 'entryGate') {
      let index = this.entryGate.indexOf(data);
      data.selected = !data.selected;
      this.entryGate[index] = data;

      if (data.selected == true) {
        // let userAccessPointChanged:{ type: string; AccessPointId: any; CreatedBy: any; };
        // userAccessPointChanged.type=data.type;
        // userAccessPointChanged.AccessPointId=data.id;
        // userAccessPointChanged.CreatedBy=data.createdBy;
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy
        });

        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        // this.useraccessPointChanged.splice()
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true
        });
      }
      if (data.selected == false) {

        this.accessPointChanged.splice(i, 1);
        // this.useraccessPointChanged.splice(i, 1);
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false
        });
        // this.accessPointChanged.push(data);
      }
      console.log("ebtry", this.entryGate)
    }
    else if (module == 'meetingRoomAccess') {
      let index = this.meetingRoomAccess.indexOf(data);
      data.selected = !data.selected;
      this.meetingRoomAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy
        });
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false
        });
      }
      console.log("ebtry", this.entryGate)
    }
    else if (module == 'deskAccess') {
      let index = this.deskAccess.indexOf(data);
      data.selected = !data.selected;
      this.deskAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy
        });
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false
        });
      }
      console.log("ebtry", this.entryGate)
    }
    else if (module == 'privateSuiteAccess') {
      let index = this.privateSuiteAccess.indexOf(data);
      data.selected = !data.selected;
      this.privateSuiteAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy
        });
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0)
          this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false
        });
      }
      console.log("ebtry", this.entryGate);

    }
    console.log('useraccessPointChanged', this.useraccessPointChanged);
    // this.accessPointChanged.push(this.meetingRoomAccess.forEach(item => item.selected = true));
    // this.accessPointChanged.push(this.deskAccess.forEach(item => item.selected = true));
    // this.accessPointChanged.push(this.privateSuiteAccess.forEach(item => item.selected = true));
    // console.log("this.accessPoint",this.accessPointChanged)
    // this.accessPointChanged-this.deskAccess.forEach(item => item.selected = true);
    // this.accessPointChanged= this.privateSuiteAccess.forEach(item => item.selected = true);

    console.log('useraccessPointChanged', this.useraccessPointChanged);

    this.checkAllAccessStatus()
  }

  checkAllAccessStatus() {
    if (this.useraccessPointChanged.some(access => access.hasAccess == false))
      this.selectAll = false;
    else
      this.selectAll = true;
  }
  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
      if (this.fullname.length != 0) {
        this.name = true;
      }
    }

    if (field == 'email') {
      this.email = !this.email;
      if (this.emailId.length != 0) {
        this.email = true;
      }
    }

    if (field == 'mobile') {
      this.mobile = !this.mobile;
      if (this.phoneNumber.length != 0) {
        this.mobile = true;
      }
      if (this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '+91';
        return
      }
      else if (!this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '';
        return;
      }
    }

    if (field == 'department') {
      if (this.departmentName.length != 0) {
        this.dept = true;
      }
      this.dept = !this.dept;
    }
  }


  addEmployee() {
    this.router.navigate(["/employees/employees-list/add-employees/employee-add-status"]);
  }
  // changeMeetingRoomAccess(eg){
  //   let index = this.meetingRoomAccess.indexOf(eg);
  //   eg.selected = !eg.selected;
  //   this.meetingRoomAccess[index] = eg;
  //  console.log("ebtry",this.entryGate)
  // }


  keyPressNumbersDecimal(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  keyPressAlphaNumbersDecimal(event) {
    var inp = String.fromCharCode(event.keyCode);
    var charCode = (event.which) ? event.which : event.keyCode;
    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      if (charCode != 32) {
        event.preventDefault();
        return false;
      }
    }
  }

  keyPressAlphaSpecial(event) {
    // var inp = String.fromCharCode(event.keyCode);
    // var charCode = (event.which) ? event.which : event.keyCode;

  }
  textToLower(){
    if(this.emailId)
    this.emailId=this.emailId.toLowerCase();
  }
}
